import { render, staticRenderFns } from "./RewardsSentLog.vue?vue&type=template&id=2dc16fa2&scoped=true"
import script from "./RewardsSentLog.vue?vue&type=script&lang=js"
export * from "./RewardsSentLog.vue?vue&type=script&lang=js"
import style0 from "./RewardsSentLog.vue?vue&type=style&index=0&id=2dc16fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc16fa2",
  null
  
)

export default component.exports